import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.quick-facts .box h2').forEach(h2 => {
    const original = h2.textContent.trim();
    // Capture optional prefix, the numeric value (with optional decimal), and everything after
    const match = original.match(/^([^0-9]*)(\d+\.?\d*)(.*)$/);
    if (!match) return;

    const [, prefix, numStr, suffix] = match;
    const target = parseFloat(numStr);
    const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
    const counter = { value: 0 };

    ScrollTrigger.create({
        trigger: h2,
        start: 'top 85%',
        once: true,
        onEnter() {
            gsap.to(counter, {
                value: target,
                duration: 2,
                ease: 'power2.out',
                onUpdate() {
                    h2.textContent = prefix + counter.value.toFixed(decimals);
                },
                onComplete() {
                    h2.textContent = prefix + target.toFixed(decimals) + suffix;
                },
            });
        },
    });
});
